<template>
  <div class="today-alarm dn-content-bg"  >
        <div :id="echartsId"
            class="lineBox"
            ref="lineBoxTwo" v-resize="resize"></div>
  </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
export default {
    beforeRouteLeave(to, form, next) {
    },
    props: {
        echartsData: {
            type: Object,
            default: () => ({})
        },
        direction: {
            type: String,
            default: 'bottom'
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            echarts: null,
            echartsId: uuidv1(),
            boxId: uuidv1(),
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        resize() {
            let vm = this;
            if (vm.echarts) {
                vm.echarts.resize();
            }
        },
        //调接口拿取数据
        getData() {
            this.getLineEchart(this.echartsData)
        },
        getLineEchart(obj) {
            let vm = this
            if (vm.echarts == null) {
                vm.echarts = vm.$echarts.init(document.getElementById(vm.echartsId))
            } else {
                vm.echarts.clear()
            }
            let legend=null
            let tooltip=null
                legend={
                    left: 'center',
                    top: '2%',
                    data: obj.legend,
                    textStyle:{
                        color:"#666"
                    },
                    type:'scroll'
                }
            if(vm.type=='rate'){
                tooltip={
                    trigger: 'axis',
                    textStyle:{
                        align:'left'
                    },
                    confine:true,/* 限制在框内 */
                    formatter(array){
                        let str = ""
                        for (let index = 0; index < array.length; index++) {
                            const time=array[index].axisValue
                            console.log(index)
                            const data =  array[index].data;
                            const seriesName =  array[index].seriesName;
                            if(index==0){
                                str+=`<span >${time}<br/>${seriesName}:${data}%</span><br/>`
                            }else{
                                str+=`<span >${seriesName}:${data}%</span><br/>`
                            }
                        }
                        return str;
                    }
                }
            }else{
                tooltip={
                    trigger: "axis",
                    confine:true,
                    textStyle:{
                        align:'left'
                    }
                }
            }
            let toolbox={}
            /* 定额分析专享 */
            if(obj.magicType){
                toolbox={
                    feature: {
                        saveAsImage: {
                            type:'png'
                        },
                        dataView:{
                            show:true
                        },
                        magicType: {
                            type: ["line", "bar"],
                        }, //切换为折线图，切换为柱状图
                    },
                    right: "150",
                    top:"10"
                }
            }
            var option = {
                legend: legend,
                grid: {
                    left: "5%",
                    right: "5%",
                    top: "15%",
                    bottom: "10%",
                },
                tooltip:tooltip,
                color: ['#7ad7db', '#b2a5da', '#2FB939','#409eff'],
                xAxis: {
                    type: 'category',
                    data: obj.xData,
                    // boundaryGap: false,
                    axisLine:{
                        lineStyle:{
                            color:"#666"
                        }
                    }
                },
                toolbox: toolbox,
                yAxis: {
                    type: 'value',
                    name: obj.unit,
                    // scale: true /*按比例显示*/,
                    axisLine:{
                        lineStyle:{
                            color:"#666"
                        }
                    }
                },
                series: obj.series
            }
            vm.echarts.setOption(option, true)
            window.addEventListener('resize', function() {
                vm.echarts.resize()
            })
        },
    },
    watch: {
        echartsData: {
            handler(newVal, oldVal) {
                this.getData()
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    height: 100%;
    width: 100%;
}
.lineBox {
    width: 100%;
    height: 100%;
}
</style>